<template>
  <el-card class="gold-widget">
    <div v-if="$slots.header" slot="header">
        <slot name="header"></slot>
        <span v-if="combinedTotal" class="d-inline-block pull-right my-auto pt-1 font-weight-bold">
            <span class="text-muted small">Total </span>
            {{ combinedTotalFormatted }}
        </span>
    </div>
    <div class="row dashboard-widget-broker-body mb-2" v-if="combinedTotal">
      <el-radio-group v-model="metric" class="mx-3 mt-3 mb-2" @change="getTeamLeaderboards">
        <el-radio-button label="Settled"></el-radio-button>
        <el-radio-button label="NAF"></el-radio-button>
        <el-radio-button label="Income"></el-radio-button>
      </el-radio-group>
      <horizontal-bar-chart v-if="loaded" :data="datasets" :options="options" class="col-12" :style="{'height': ((totalTeams * 40) + 40) + 'px'}"></horizontal-bar-chart>
    </div>
    <div class="row col-12 my-2" v-else>
      <span class="text-muted small">No results available</span>
    </div>
  </el-card>
</template>


<script>
import HorizontalBarChart from "./charts/HorizontalBarChart";
export default {
  components: {
    HorizontalBarChart
  },
  props: {
    token: {
      type: String,
      required: true
    },
    dateScope: {
      type: Object,
      required: true
    },
    teamId: {
      type: [Number, String],
      required: false
    },
    brokerId: {
        type: Number,
        required: false
    },
  },
  data() {
    return {
      metric: 'Settled',
      loadedMetric: 'Settled',
      teamStats: [],
      labels: [],
      datasets: [],
      loaded: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
            animationDuration: 1
        },
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        },
        scales: {
            xAxes: [{
                stacked: true,
                barPercentage: 1,
                categoryPercentage: 0.8,
                ticks: {
                    precision: 0,
                    fontFamily: "Poppins",
                    padding: 5,
                    boxWidth: 15,
                    fontSize: 12,
                    fontColor: "#000",
                    fontStyle: "normal",
                    callback: function(value, index, values) {
                      if (this.metric == 'Settled') {
                        return this.commarize(String(Math.round(value)));
                      } else {
                        return '$' + this.commarize(String(value));
                      }
                    }.bind(this)
                }
            }],
            yAxes: [{
                stacked: true,
                barPercentage: 1,
                categoryPercentage: 0.8,
                ticks: {
                    // display: false,
                    fontFamily: "Poppins",
                    padding: 5,
                    boxWidth: 15,
                    fontSize: 12,
                    fontColor: "#000",
                    fontStyle: "normal",
                    callback: function(value, index, values) {
                      if (String(value).length > 15)
                        return String(value).substring(0, 13) + '...'
                      else
                        return value;
                    }
                }
            }]
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontFamily: "Poppins",
            padding: 16,
            boxWidth: 15,
            fontSize: 12,
            fontColor: "#000",
            fontStyle: "normal"
          }
        },
        tooltips: {
          titleFontFamily: "Poppins",
          titleFontSize: 12,
          titleMarginBottom: 15,
          bodyFontFamily: "Poppins",
          bodyFontSize: 12,
          bodySpacing: 15,
          cornerRadius: 0,
          intersect: true,
          xPadding: 10,
          yPadding: 10,
          backgroundColor: 'rgba(8,7,48,0.8)',
          color: '#ffffff',
          callbacks: {
            title: function(t, d) {
              var idx = t[0].index;
              return d.labels[idx];
            },
            label: function(t, d) {
              var dstLabel = this.metric; //d.datasets[t.datasetIndex].label.replace(/ .*/,'');
              var xLabel = t.xLabel;
              if (this.loadedMetric == 'Settled') {
                return ' ' + dstLabel + ': ' + Number(xLabel);
              } else {
                return ' ' + dstLabel + ': $' + Number(xLabel).toLocaleString("en-AU", { maximumFractionDigits: 2 });
              }
            }.bind(this)
          },
          enabled: false,
          custom: function(tooltipModel) {
              // Tooltip Element
              var tooltipEl = document.getElementById('chartjs-tooltip');

              // Create element on first render
              if (!tooltipEl) {
                  tooltipEl = document.createElement('div');
                  tooltipEl.id = 'chartjs-tooltip';
                  tooltipEl.innerHTML = '<table></table>';
                  document.body.appendChild(tooltipEl);
              }

              // Hide if no tooltip
              if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
              }

              // Set caret Position
              tooltipEl.classList.remove('above', 'below', 'no-transform');
              if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
              } else {
                  tooltipEl.classList.add('no-transform');
              }

              function getBody(bodyItem) {
                  return bodyItem.lines;
              }

              // Set Text
              if (tooltipModel.body) {
                  var titleLines = tooltipModel.title || [];
                  var bodyLines = tooltipModel.body.map(getBody);

                  var innerHtml = '<thead>';

                  titleLines.forEach(function(title) {
                      innerHtml += '<tr><th>' + title + '</th></tr>';
                  });
                  innerHtml += '</thead><tbody>';

                  bodyLines.forEach(function(body, i) {
                      var colors = tooltipModel.labelColors[i];
                      var style = 'background:' + colors.backgroundColor;
                      style += '; border-color:' + colors.borderColor;
                      style += '; border-width: 2px';
                      var span = '<span style="' + style + '"></span>';
                      innerHtml += '<tr><td>' + span + body + '</td></tr>';
                  });
                  innerHtml += '</tbody>';

                  var tableRoot = tooltipEl.querySelector('table');
                  tableRoot.innerHTML = innerHtml;
              }

              // `this` will be the overall tooltip
              var position = this._chart.canvas.getBoundingClientRect();

              // Display, position, and set styles for font
              tooltipEl.style.opacity = 1;
              tooltipEl.style.position = 'absolute';
              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 10 + 'px';
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY - 30 + 'px';
              tooltipEl.style.backgroundColor = tooltipModel.backgroundColor;
              tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
              tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
              tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
              tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
              tooltipEl.style.pointerEvents = 'none';
          }
        },
        animation: {
          duration: 500,
          easing: "easeOutQuart",
          onComplete: function (chartElement) {
            var ctx = chartElement.chart.ctx;
            ctx.font = Chart.helpers.fontString(14, 'bold', 'Poppins');
            ctx.textAlign = 'right';
            ctx.textBaseline = 'bottom';

            chartElement.chart.data.datasets.forEach(function (dataset) {
              for (var i = 0; i < dataset.data.length; i++) {
                var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                    left = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._xScale.left,
                    right = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model.x;
                var dataIndex = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._index;
                var broker = Object.values(this.teamStats.labels)[dataIndex];

                ctx.fillStyle = this.adjust('#fff', 0);

                var label = '';
                if (this.loadedMetric == 'Settled') {
                  label = Number(dataset.data[i]);
                } else {
                  label = '$' + this.commarize(String(dataset.data[i])); // '$' + Number(dataset.data[i]).toLocaleString("en-AU", { maximumFractionDigits: 0 });
                }

                var text = ctx.measureText(label);

                if (text.width < (right - left - 10)) {
                  ctx.fillText(label, right - 5, model.y + 8, right - left);
                }

              }
            }.bind(this));
          }.bind(this)
        }
      }
    };
  },
  mounted() {
    this.refreshData();
  },
  created() {
    this.$bus.$on("refreshed-data", value => {
      this.refreshData();
    });
  },
  computed: {
    combinedTotal() {
			let total = 0;
			if (this.metric == 'Settled') {
        total = _.reduce(_.get(this.teamStats, 'values.total_settlements', []), (sum, x) => sum + x) || 0;
			} else if (this.metric == 'NAF') {
        total = _.reduce(_.get(this.teamStats, 'values.total_naf', []), (sum, x) => sum + x) || 0;
			} else if (this.metric == 'Income') {
        total = _.reduce(_.get(this.teamStats, 'values.total_income', []), (sum, x) => sum + x) || 0;
			}
			return total;
    },
    combinedTotalFormatted() {
			let total = this.combinedTotal;
			if (this.metric == 'Settled') {
				return total;
			} else if (this.metric == 'NAF') {
				return '$' + Number(total).toLocaleString("en-AU", { maximumFractionDigits: 0 });
			} else if (this.metric == 'Income') {
				return '$' + Number(total).toLocaleString("en-AU", { maximumFractionDigits: 0 });
			}
			return total;
    },
    totalTeams() {
      return this.teamStats.labels.length || 0;
    }
  },
  watch: {
    dateScope: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    teamId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    brokerId: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    }
  },
  methods: {
    refreshData() {
      this.getTeamLeaderboards();
    },
    async getTeamLeaderboards() {

			let res = await axios.get(`/api/v2/team-leaderboards`, {
				headers: {
					Authorization: `Bearer ${this.token}`
				},
				params: {
					startDate: this.$moment(this.dateScope.startDate).format('YYYY-MM-DD'),
					endDate: this.$moment(this.dateScope.endDate).format('YYYY-MM-DD'),
					teamId: this.teamId,
					brokerId: this.brokerId,
          metric: this.metric
				}
			});

			this.teamStats = res.data;

			if (this.combinedTotal) {

				let labels = Object.values(this.teamStats.labels);
				// let logos = Object.values(this.teamStats.logos);

				let values = [];

				if (this.metric == 'Settled') {
					values = this.teamStats.values.total_settlements;
				} else if (this.metric == 'NAF') {
					values = this.teamStats.values.total_naf;
				} else if (this.metric == 'Income') {
					values = this.teamStats.values.total_income;
				}

				this.datasets = {
						datasets: [{
								label: 'Total Settlements',
								data: Object.values(values),
                backgroundColor: '#D4AF37',
						}],
						labels: labels
				};

			}

			this.loaded = true;
			this.loadedMetric = this.metric;

    },
    commarize(val, min) {
        min = min || 1e3;
        // Alter numbers larger than 1k
        if (val >= min) {
          var units = ["k", "M", "B", "T"];

          var order = Math.floor(Math.log(val) / Math.log(1000));

          var unitname = units[(order - 1)];
          var num = Math.floor(val / 1000 ** order);

          if (String(num).length == 1) {
            num = Number(val / 1000 ** order).toFixed(1);
            if (num == Number(num)) {
              num = Number(num);
            }
          }
          return num + unitname;
        }
        return val.toLocaleString();
    },
    adjust(color, amount) {
        return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
    }
  }
};
</script>

<style scoped>

  .team-logo {
    height: 41px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
		-webkit-transition: background-image 0.2s ease-in-out;
		transition: background-image 0.2s ease-in-out;
  }

  .team-logo .team-text {
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .dashboard-widget-broker-body .el-radio-group {
    width: 100%;
  }

  .dashboard-widget-broker-body .el-radio-button {
    width: 33.3%;
  }

</style>

<style scoped>

  #marker-dashboard-page .card {
    border: none;
  }

  .dashboard-widget-broker-body .el-radio-button .el-radio-button__inner {
    width: 100%;
    border-radius: 0px !important;
  }

  #chartjs-tooltip th, #chartjs-tooltip td {
    color: #fff !important;
  }

  .el-radio-button__inner {
    background: transparent;
    border: 1px solid #D4AF37;
    border-left: 0;
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border-left: 1px solid #D4AF37;
  }

  .dashboard-widget-broker-body .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #D4AF37;
    border-color: #D4AF37;
    -webkit-box-shadow: -1px 0 0 0 #D4AF37;
    box-shadow: -1px 0 0 0 #D4AF37;
  }

  .dashboard-widget-broker-body .el-radio-button:not(.is-active) .el-radio-button__inner:hover {
    color: #D4AF37 !important;
  }

  body.product-ambition-backend #marker-dashboard-page .gold-widget h3 {
    color: #D4AF37 !important;
  }

  body.product-ambition-backend #marker-dashboard-page .gold-widget .el-radio-button__inner {
    border-color: #D4AF37 !important;
  }

  .dashboard-widget-broker-body  .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
    -webkit-box-shadow: 0 0 2px 2px #D4AF37;
    box-shadow: 0 0 2px 2px #D4AF37;
  }

  #chartjs-tooltip {
    -moz-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }

  #chartjs-tooltip:after {
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 6px);
    left: -6px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgba(8, 7, 48, 0.8);
    z-index: 10000;
  }

</style>

<style>
  canvas#race{position:relative; z-index:1;}
</style>
